import type { Icon } from '../../../src/lib/types'
export const mdiAlignVerticalCenter: Icon = {
  "id": "align-vertical-center",
  "name": "Align Vertical Center",
  "path": "M22 11H17V6H14V11H10V3H7V11H1.8V13H7V21H10V13H14V18H17V13H22V11Z",
  "as": [
    "align-vertical-centre"
  ],
  "tags": []
}
export default mdiAlignVerticalCenter